import Vue from 'vue'
import Router from 'vue-router'
import routes from '@/routes/routes'

import i18n from '@/i18n'
import authenticationService from 'Services/AuthenticationService'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

const onAuthorized = (to, next) => {
  if (store.getters.isContextSelected() || to.name === 'contextSelection' || to.matched.some(record => record.meta.noContextRequired)) {
    next()
  } else {
    next({ name: 'contextSelection', params: { route: { name: to.name, params: to.params } } })
  }
}

router.beforeEach((to, from, next) => {
  store.dispatch('navigate', { to, from })

  if (to.matched.some(record => record.meta.isPublic)) {
    next()
  } else if (store.getters.isAuthorized()) {
    onAuthorized(to, next)
  } else {
    const { refreshToken = null } = store.state.authorization.credentials || {}
    if (refreshToken !== null) {
      store.dispatch('refresh', refreshToken).then(() => {
        onAuthorized(to, next)
      }).catch(() => {
        store.dispatch('showMessage', { title: i18n.t('sentence.refreshTokenErrorMessage'), options: { variant: 'danger' } })
        next('/')
      })
    } else {
      window.location = authenticationService.getLoginRedirectUri(to.name === 'contextSelection' ? 'dashboard' : to.path)
    }
  }
})

export default router
